module.exports = __webpack_public_path__ + "static/AMA20 Finalist Medal_Brokerage of the Year - 6-20 Staff-12df3b97f5842d5747e7fc9d9d057205.png";